<div class="dialog">
  <img src="/assets/icons/special/video-beta.svg" alt="" />

  <div class="label label-orange">BETA FEATURE</div>

  <h1>Upload Video</h1>

  <p>Uploading and playing video on Picflow is available as a beta feature. Try it now!</p>

  <a
    [routerLink]="['/a', 'settings', 'beta-features']"
    appButton
    name="confirm"
    location="video-beta-dialog"
    color="primary"
    shape="round"
    height="4"
    spacing="4"
    size="3"
    [center]="true"
  >
    Enable Beta Feature
  </a>
</div>
